import { http } from '@/providers/apis/http';
import { taxonomySerializer } from '@/providers/serializers/taxonomy/taxonomy';
import { SubjectModel } from '@/models/taxonomy/subject';
import { ClassificationModel } from '@/models/taxonomy/classification';
import { GradeModel } from '@/models/taxonomy/grade';
import { TxGradeBoundary } from '@/models/taxonomy/grade-boundary';
import { TaxonomyCode } from '@/models/taxonomy/code';
import { CourseModel } from '@/models/taxonomy/course';

export class TaxonomyAPI {

  private static INSTANCE = new TaxonomyAPI();

  private namespace = 'api/nucleus/v2/taxonomy';

  private taxonomyNamespace = 'api/nucleus/v1/taxonomy';

  private dsNamespace = 'api/ds/users/v2/tx';

  private namespace1 = 'api/nucleus/v1/taxonomy';

  static get instance() {
    return this.INSTANCE;
  }

  public fetchTaxonomyClassifications(): Promise<ClassificationModel[]> {
    const endpoint = `${this.namespace}/classifications`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return taxonomySerializer.serializeTaxonomyClassifications(response.data);
    });
  }

  public fetchTaxonomySubjects(category: string): Promise<SubjectModel[]> {
    const endpoint = `${this.dsNamespace}/subjects`;
    const headers = http.getTokenHeaders();
    const data = {
      classificationType: category,
    };
    return http.get(endpoint, headers, data).then((response) => {
      return taxonomySerializer.serializeTaxonomySubjects(response.data);
    });
  }


  public fetchSubjects(category: string): Promise<SubjectModel[]> {
    const endpoint = `${this.taxonomyNamespace}/subjects`;
    const headers = http.getTokenHeaders();
    const data = {
      classification_type: category,
    };
    return http.get(endpoint, headers, data).then((response) => {
      return taxonomySerializer.serializeTaxonomySubjects(response.data);
    });
  }

  public fetchTaxonomyCourse(subject: any): Promise<CourseModel[]> {
    const endpoint = `${this.taxonomyNamespace}/frameworks/${subject.frameworkId || 'GDT'}/subjects/${subject.id}/courses`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return taxonomySerializer.serializeTaxonomyCourse(response.data);
    });
  }

  public fetchTaxonomyGrades(subject: string, framework?: any): Promise<GradeModel[]> {
    const endpoint = `${this.dsNamespace}/grades`;
    const headers = http.getTokenHeaders();
    const data = {
      subject,
      framework,
    };
    return http.get(endpoint, headers, data).then((response) => {
      return taxonomySerializer.serializeTaxonomyGrades(response.data);
    });
  }

  public fetchTaxonomyGradeBoundaries(gradeId: number | any): Promise<TxGradeBoundary[]> {
    const endpoint = `${this.dsNamespace}/grade/boundary/${gradeId}`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return taxonomySerializer.serializeTaxonomyGradeBoundaries(response.data);
    });
  }

  public fetchDomains(frameworkId: any, subjectId: any, courseId: any) {
   const adapter = this;
   const namespace = this.taxonomyNamespace;
   if (!frameworkId) {
     frameworkId = 'GDT';
   }
   const url = `${namespace}/frameworks/${frameworkId}/subjects/${subjectId}/courses/${courseId}/domains`;
   const header = http.getTokenHeaders();
   return http.get(url, header).then((response) => {
     return taxonomySerializer.serializeTaxonomyGradeBoundaries(response.data);
   });
 }

  public fetchTaxonomyCodes(
    frameworkId: string,
    subjectId: string,
    courseId: string,
    domainId: string): Promise<TaxonomyCode[]> {
      if (!frameworkId) {
        frameworkId = 'GDT';
      }
      const endpoint = `${this.taxonomyNamespace}/frameworks/${frameworkId}/subjects/${
      subjectId}/courses/${courseId}/domains/${domainId}/codes`;
      const headers = http.getTokenHeaders();
      return http.get(endpoint, headers).then((response) => {
      return taxonomySerializer.serializeTaxonomyCodes(response.data);

    });
  }

  public fetchCodes(frameworkId: any, subjectId: any, courseId: any, domainId: any): Promise<any> {
    const namespace = this.namespace1;
    const endpoint = `${namespace}/frameworks/${frameworkId}/subjects/${
      subjectId}/courses/${courseId}/domains/${domainId}/codes`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return taxonomySerializer.normalizefetchCode(response.data);
    });
  }
  public fetchCrossWalk(frameworkId: string, subjectId: string, isIncludeMicro = false) {
    const namespace = this.taxonomyNamespace;
    const url = `${namespace}/crosswalk/frameworks/${frameworkId}/subjects/${subjectId}`;
    const header = http.getTokenHeaders();
    const data = {
      include_mcomp: isIncludeMicro,
    };
    return http.get(url, header, data).then((response) => {
      return taxonomySerializer.normalizeCrosswalkCompetencyData(frameworkId, response.data);
    });
  }

  public fetchFWCrosswalk(frameworkId: string, subjectId: any) {
    const endpoint = `${this.namespace}/crosswalk/frameworks/${frameworkId}/subjects/${subjectId}`;
    const header = http.getTokenHeaders();
    return http.get(endpoint, header).then((response) => {
      return taxonomySerializer.serializeTaxonomyCrosseWalkFC(response.data);
    });
  }

  public fetchFrameworks(subjectCode: string) {
    const endpoint = `${this.namespace1}/frameworks/subjects`;
    const headers = http.getTokenHeaders();
    const data = {
      subject: subjectCode,
    };
    return http.get(endpoint, headers, data).then((response) => {
      return taxonomySerializer.serializeTaxonomyFrameWork(response.data);
    });
  }

  public fetchSubjectById(subjectCode: string) {
    const endpoint = `${this.namespace1}/subjects/${subjectCode}`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return response.data;
    }).catch(() => {
      return {};
    });
  }
}

export const taxonomyAPI = TaxonomyAPI.instance;
